import React from 'react';
import { Tag as PTag } from 'primereact/tag';
import classnames from 'classnames';
import { ITag, TagSize, TagVariant } from './Tag.types';
import styles from './Tag.module.scss';

const TagVariantClassName = {
  [TagVariant.Default]: 'tag-default',
  [TagVariant.Primary]: 'tag-primary',
  [TagVariant.Secondary]: 'tag-secondary',
  [TagVariant.Error]: 'tag-error',
  [TagVariant.Info]: 'tag-info',
  [TagVariant.Success]: 'tag-success',
  [TagVariant.Warning]: 'tag-warning',
  [TagVariant.Linolium]: 'tag-linolium',
  [TagVariant.Eggplant]: 'tag-eggplant',
};

const TagSizeClassName = {
  [TagSize.Small]: 'tag-size-small',
  [TagSize.Medium]: 'tag-size-medium',
  [TagSize.Large]: 'tag-size-large',
};

export const Tag: React.FC<ITag> = ({
  value,
  children,
  className = '',
  variant = TagVariant.Secondary,
  size = TagSize.Medium,
  rounded = false,
  ...restProps
}) => {
  const classNames = classnames(
    styles['ds-tag-element'],
    className,
    styles[TagVariantClassName[variant]],
    styles[TagSizeClassName[size]],
    {
      [styles['rounded']]: rounded,
    }
  );

  return (
    <PTag className={classNames} {...restProps}>
      {children}
    </PTag>
  );
};
